var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeHideLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_732_1256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1885 10.8657C13.3326 10.4806 13.4057 10.0726 13.4042 9.66141C13.4042 8.74846 13.0416 7.8729 12.396 7.22734C11.7505 6.58179 10.8749 6.21912 9.96195 6.21912C9.55585 6.21959 9.15309 6.29266 8.77271 6.43489L9.58059 7.26786C9.7034 7.24821 9.82755 7.23815 9.95192 7.23775C10.5974 7.23641 11.2173 7.49053 11.6761 7.94463C12.1349 8.39872 12.3954 9.01591 12.4007 9.66141C12.4002 9.78578 12.3902 9.90993 12.3706 10.0327L13.1885 10.8657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7548 9.42551C16.0637 6.29935 13.0981 4.40759 9.8164 4.40759C8.92289 4.40969 8.03537 4.55366 7.18701 4.83412L7.9949 5.64702C8.58995 5.49324 9.20181 5.41401 9.8164 5.41118C12.6415 5.41118 15.2107 6.9868 16.7411 9.64128C16.1797 10.6261 15.4354 11.4947 14.5483 12.2004L15.2608 12.913C16.2876 12.0847 17.1402 11.0615 17.7698 9.90222L17.9003 9.66136L17.7548 9.42551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.99214 3.52941L5.23013 5.7674C3.81554 6.67821 2.6594 7.93804 1.87314 9.42547L1.74268 9.66131L1.87314 9.90217C3.56418 13.0283 6.52977 14.9201 9.81149 14.9201C11.0924 14.9198 12.3567 14.6299 13.5097 14.0721L16.0187 16.581L16.8968 15.8283L3.8502 2.78174L2.99214 3.52941ZM7.88461 8.42188L11.2215 11.7588C10.8445 11.9922 10.4105 12.1172 9.96705 12.1201C9.64486 12.1201 9.32586 12.0564 9.02838 11.9326C8.73091 11.8089 8.46085 11.6275 8.23373 11.399C8.00661 11.1705 7.82692 10.8993 7.705 10.6011C7.58308 10.3029 7.52134 9.98349 7.52332 9.66131C7.52897 9.22302 7.65387 8.79455 7.88461 8.42188ZM7.15701 7.69428C6.68755 8.35635 6.46751 9.16318 6.53585 9.97191C6.60419 10.7806 6.9565 11.5391 7.5304 12.113C8.1043 12.6869 8.86276 13.0392 9.6715 13.1076C10.4802 13.1759 11.2871 12.9559 11.9491 12.4864L12.752 13.2893C11.8226 13.6866 10.8223 13.8914 9.81149 13.8914C6.9864 13.8914 4.41723 12.3158 2.88676 9.66131C3.62124 8.36077 4.67902 7.27188 5.95773 6.50002L7.15701 7.69428Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_732_1256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0645,
    height: 18.0645,
    fill: "white",
    transform: "translate(0.54834 0.629028)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHideLine);
export default __webpack_public_path__ + "static/media/eye-hide-line.ac7789c271ebfec7844ef2e52c98ec6b.svg";
export { ForwardRef as ReactComponent };